import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type { PublicFacilityResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Resolve a facility_id → its PublicFacilityResponse (for the NAME). Affiliations and
 * the request-a-lesson facility picker carry only a facility_id; the page never
 * renders the raw uuid — it resolves the name via facilityApi.getPublic. Keyed by the
 * facility_id so each facility resolves into its own cache slot (shared across
 * the affiliations section + the request form).
 */
export function useFacilityName(facilityId: string | undefined) {
  return useQuery<PublicFacilityResponse>({
    queryKey: queryKeys.coaches.facility(facilityId ?? ""),
    queryFn: () => facilityApi.getPublic(facilityId as string),
    enabled: Boolean(facilityId),
  });
}
